import React from 'react';
import classNames from 'classnames';
import { ProbeStatus } from './types';

const STATUS_LABELS: Record<ProbeStatus, string> = {
	[ProbeStatus.Ok]: 'OK',
	[ProbeStatus.Empty]: 'IDLE',
	[ProbeStatus.Degraded]: 'DEGRADED',
	[ProbeStatus.Error]: 'ERROR',
};

interface Props {
	status: ProbeStatus;
	label?: string; /** Overrides the default label, e.g. the room session status string. */
	large?: boolean;
}

export default function StatusPill({ status, label, large = false }: Props) {
	return (
		<span className={classNames('health-pill', `health-pill--${status}`, { 'health-pill--large': large })}>
			{label ?? STATUS_LABELS[status]}
		</span>
	);
}
